import React from 'react';
import { TranslationConsumer } from 'giro-react-toolkit/source/Translation';

import "./LanguageSelection.scss"

/**
 * Component used to select a language.
 */
function LanguageSelection(props) {
   return (
      <TranslationConsumer>
         {({ supportedCultures, currentCulture }) => {
            if (supportedCultures.length < 2)
               return (null);

            return (
               <div className={"language " + props.className}>
                  { !props.inLineMode && <div className="language__icon"></div> }
                  <select
                     className="language__select"
                     name="language"
                     value={currentCulture}
                     onChange={(e) => {
                              // Faire un redirection qui permet au serveur de changer la langue courante.
                              // Il est possible que le routing (react-router ou autre) ne soit pas compatible
                              // avec ce type de redirection.
                        document.location.href = document.baseURI + "?culture=" + e.target.value;
                     }}>
                     {
                        supportedCultures.map(lang => {
                           return (
                              <option key={lang} value={lang}>{reachMap.culturesDisplayNames[lang]}</option>
                           );
                        })
                     }
                  </select>
               </div>
            );
         }}
      </TranslationConsumer>
   );
}

export default LanguageSelection;
